import React, { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { getUsername } from "../../../../ducks/user";
import { CheckboxDescription, TextLine } from "../../DeleteLayer/styled";
import { UsersTooltip } from "../../DeleteLayer/UsersTooltip";
import { ResourcesResolved } from "../resolveResources";
import { userNamesWithAccess } from "./userNamesWithAccess";

export const UsersInfo: FC<Pick<ResourcesResolved, "layers">> = ({ layers }) => {
  const { t } = useTranslation("dialogs");
  const currentUser: string = useSelector(getUsername);
  const usersWithLayersAccessNames = useMemo(
    () => userNamesWithAccess(layers, currentUser, t("access.public")),
    [layers, currentUser, t],
  );

  if (usersWithLayersAccessNames.length === 0) {
    return null;
  }

  return (
    <CheckboxDescription>
      <TextLine>
        <span>
          {t("deleteResources.usersWithAccess").replace("{resourceType}", t("deleteResources.toLayers"))}&nbsp;
        </span>
        <UsersTooltip users={usersWithLayersAccessNames} />
      </TextLine>
      <TextLine>
        <span>{t("deleteResources.unavailableUsersCatalog")}</span>
      </TextLine>
    </CheckboxDescription>
  );
};
